// removed by extract-text-webpack-plugin
module.exports = {"buttonLink":"ListPage--buttonLink--5tJcfsc8","button":"ListPage--button--3OtR-Yyw","surveyName":"ListPage--surveyName--TrwTIgxc","openThruDate":"ListPage--openThruDate--Xs_hZro8","action":"ListPage--action--39dD00aL","messageActions":"ListPage--messageActions--3_eHO11n","messageListContainer":"ListPage--messageListContainer--oPfM72UD"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/Surveys/ListPage.css
// module id = 1230
// module chunks = 2